module.exports = __webpack_public_path__ + "static/media/facility-right-banner-1.bf91cd44.jpg";